module.exports = __webpack_public_path__ + "media/video_BrityRPA.ea65e84b.mp4";